import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Credly|Duplicates|';
const sharedProperties: Pick<LocDef, 'shared' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.ShareCredlyBadging,
	portal: 'SP',
};

type LocNameStart = 'SPToolsCredlyDuplicates';
export type SPToolsCredlyDuplicatesLocNames =
	| `${LocNameStart}TitlePageSection`
	| `${LocNameStart}ContentDuplicatesFound`
	| `${LocNameStart}LabelCmcId`
	| `${LocNameStart}LabelCertmetricsId`
	| `${LocNameStart}LabelCredlyId`
	| `${LocNameStart}LabelNameFirst`
	| `${LocNameStart}LabelNameLast`
	| `${LocNameStart}LabelEmail`;

export const spToolsCredlyDuplicatesLocs: LocDefs<SPToolsCredlyDuplicatesLocNames> = {
	SPToolsCredlyDuplicatesTitlePageSection: {
		defaultValue: 'Credly Mismatched or Duplicate Emails',
		description: 'Page Section Title',
		displayPath: `${pathStart}Page Section Title`,
		displayType: 'Title',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.PageSectionTitle.CredlyAnomalies',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPToolsCredlyDuplicatesContentDuplicatesFound: {
		defaultValue: `This candidate's email address was found on multiple candidate accounts or is listed as a Credly ID under another profile. Please review the search results to investigate further.`,
		description: 'Text shown when duplicates are found in Credly search results.',
		displayPath: `${pathStart}Duplicates Found`,
		displayType: 'Content',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Content.DuplicatesFound',
		htmlAllowed: true,
		...sharedProperties,
	},
	SPToolsCredlyDuplicatesLabelCmcId: {
		defaultValue: 'CMC ID',
		description: 'Column heading for: CMC ID.',
		displayPath: `${pathStart}CMC ID`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Duplicates.ColumnHeading.CMCId',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPToolsCredlyDuplicatesLabelCertmetricsId: {
		defaultValue: 'CertMetrics ID',
		description: 'Column heading for: CertMetrics ID.',
		displayPath: `${pathStart}CertMetrics ID`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Duplicates.ColumnHeading.CMId',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPToolsCredlyDuplicatesLabelCredlyId: {
		defaultValue: 'Credly ID',
		description: 'Column heading for: Credly ID.',
		displayPath: `${pathStart}Credly ID`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Duplicates.ColumnHeading.CredlyId',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPToolsCredlyDuplicatesLabelNameFirst: {
		defaultValue: 'First Name',
		description: 'Column heading for: First Name.',
		displayPath: `${pathStart}First Name`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Duplicates.ColumnHeading.FirstName',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPToolsCredlyDuplicatesLabelNameLast: {
		defaultValue: 'Last Name',
		description: 'Column heading for: Last Name.',
		displayPath: `${pathStart}Last Name`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Duplicates.ColumnHeading.LastName',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPToolsCredlyDuplicatesLabelEmail: {
		defaultValue: 'Email',
		description: 'Column heading for: Email.',
		displayPath: `${pathStart}Email`,
		displayType: 'Label',
		legacyName: 'Share.CredlyBadging/Credly.BadgeSearch.Duplicates.ColumnHeading.Email',
		htmlAllowed: false,
		...sharedProperties,
	},
};

export type SPToolsCredlyDuplicatesLocType = LocMap<SPToolsCredlyDuplicatesLocNames>;
